import {Form, Table} from "antd";
import '../../assets/css/Dentobook.css';
import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import UserIcon from "../common/UserIcon";
import dayjs from 'dayjs';
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import {useNavigate} from 'react-router-dom';
import {getPatientApi} from "../../api/apiInstances";

const GeneralData: React.FC = () => {
    const navigate = useNavigate();
    const [patients, setPatients] = useState<any[]>([]);
    const {locale} = React.useContext(DentobookApplicationContext);
    dayjs.locale(locale);

    const patientApi = getPatientApi();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {


        patientApi.fetchPatientsWithUnsentNzisData().then((response) => {
            if (
                 typeof response.data === 'undefined'
              ) {
                return;
            }
            setPatients(response.data);
        });
    }

    return (
        <div style={{paddingTop: '10px'}}>
            <Form.Item
                className={"dentobook-form-item"}
                rules={[{required: true, message: <FormattedMessage id="required_field"/>}]}
            >
            </Form.Item>
            <Table dataSource={patients}
                   pagination={false}
                   style={{paddingTop: '10px'}}
                   className="dentobook-table"
                   onRow={(record) => ({
                       onClick: () => navigate(`/patients/${record.id}?tab=nzis`), // Navigate using the record's id
                   })}>
                <Table.Column key="id" width="10%" render={(patient) => {
                    const avatarSrc = patient.avatarUrl;
                    return (
                        <div className="username-icon" >
                            {!avatarSrc ? <UserIcon size="small"/> :
                                <img className="thumbnail-img"
                                     width={10}
                                     src={avatarSrc}
                                     alt="avatar"/>
                            }
                            <span className="font-weight-500">{patient.firstName +' '+ patient.lastName}</span>
                        </div>
                    );
                }}
                              title={<FormattedMessage id="name"/>}
                              sorter={{}}
                />
                <Table.Column key="egn" width="5%" title="ЕГН"
                              sorter={{
                              }}
                              render={(patient) => <span
                                  className="font-weight-500">{patient.egn}</span>}
                />
                <Table.Column key="phone"
                              width="45%"
                              render={(patient) => <span className="font-weight-500">{patient.phone}</span>}
                              title={<FormattedMessage id="phone"/>}/>

            </Table>
        </div>
    );
};

export default GeneralData;